import "core-js/stable";
import "regenerator-runtime/runtime";
import React from "react";
import { Provider as ReduxProvider } from "react-redux";
import { ThemeProvider, StyleSheetManager } from "styled-components";
import { type EquipmentV2StateType, equipmentV2ClientStore } from "./redux/store";
import Globalize from "../../../common-deprecated/Globalize";
import getTheme from "../../../common-deprecated/themes/getTheme";
import { renderReact } from "../../../common-deprecated/utils/clientRenderUtils";
import { ModalProvider } from "../../../common-deprecated/containers/ModalProvider";
import { WindowDimensionsProvider } from "../../../common-deprecated/containers/WindowDimensionsProvider";
import { shouldForwardProp } from "../../../shared-logic/utils/styledComponentsUtils";

export const getInit =
    (EquipmentV2: React.ElementType) =>
    (target: string, props: unknown, initialState: EquipmentV2StateType): void => {
        const { commonSettings } = initialState;
        const { country, culture, currencyMultiplier } = commonSettings;

        // Initialize store, tagging and globalize.
        const store = equipmentV2ClientStore(initialState, commonSettings.component);
        Globalize(country, culture, currencyMultiplier);

        renderReact(
            target,
            commonSettings,
            // Since react-redux 8, new development checks were introduced against incorrect usages of useSelector, mostly to detect unnecessary rerenders.
            // These checks were disabled for all existing components as these create quite some issues
            // Ideally these checks should be enabled in all components - UC-1220
            // Notice: Make sure to not add the 'stabilityCheck="never"' in new components
            <ReduxProvider store={store} stabilityCheck="never">
                <StyleSheetManager shouldForwardProp={shouldForwardProp}>
                    <ThemeProvider theme={getTheme(commonSettings)}>
                        <WindowDimensionsProvider>
                            <ModalProvider>
                                <EquipmentV2 />
                            </ModalProvider>
                        </WindowDimensionsProvider>
                    </ThemeProvider>
                </StyleSheetManager>
            </ReduxProvider>,
        );
    };
